import React from 'react';
import _ from 'lodash';
import {
  Box,
  Button,

  Typography,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';




const CheckMenuList = ({ menus, allChecked, handleAllToggle, checkedMenuItems,handleParentChange, handleCheckboxChange, handleSave }) => {


  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 1
        }}
      >
        <Box>
          <FormGroup >
            <FormControlLabel control={<Checkbox checked={allChecked}
              onChange={handleAllToggle} />} label="전체" />
          </FormGroup>
        </Box>

        <Box>
          <Button color="primary" variant="contained" onClick={handleSave}>저장</Button>
        </Box>
      </Box>
      <Divider />
      <List dense sx={{ width: '100%', height: 'calc(100vh - 250px)', overflowY: 'auto' }}>
        {menus.map((menu, index) => {
          const childIds = [];
          
          _.forEach(menu.items,(item)=>{
            childIds.push(item.id);
          });

          const parentChecked = (childIds.every(v=>checkedMenuItems.includes(v)));

         

          return (
            <div key={index}>
              <ListItem>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={parentChecked}
                    indeterminate={!parentChecked}
                    onChange={(e) =>
                      handleParentChange(e,childIds)
                    }
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="subtitle2" component="div">{menu.title}</Typography>} />
              </ListItem>

              {menu.items && (
                <List component="div" dense disablePadding >

                  {menu.items.map((item, index) => {
                    const labelId = `item-list-label-${item.id}`;
                    const findIndex = _.findIndex(checkedMenuItems, (menuItem) => menuItem === item.id);
                    const checked = (findIndex !== -1) ? true : false;

                    return (
                      <ListItem

                        key={`item_${index}`}
                        sx={{ pl: 4 }}
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={checked}
                            onChange={(e) =>
                              handleCheckboxChange(e, item.id)
                            }
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ 'aria-labelledby': labelId }}
                          />
                        </ListItemIcon>
                        <ListItemText primary={<Typography variant="body2" component="div">{item.title}</Typography>} />
                      </ListItem>

                    )
                  })}

                </List>
              )}
            </div>
          )
        })}
      </List>
    </>
  )
}

export default CheckMenuList